import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { articles } from '@/mocks/categories';

export default function ArticlesSection() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="flex items-center justify-between mb-10">
          <div>
            <h2 className="text-2xl md:text-4xl font-heading font-semibold text-foreground-950">
              {t('latest_articles')}
            </h2>
            <p className="text-foreground-600 mt-2">
              {t('latest_articles_desc')}
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {articles.map((article) => (
            <div
              key={article.slug}
              className="group bg-white rounded-xl border border-background-200 overflow-hidden hover:shadow-lg transition-all duration-300 cursor-pointer"
              onClick={() => navigate(`/${article.slug}`)}
            >
              <div className="aspect-[3/2] overflow-hidden">
                <img
                  src={article.image}
                  alt={t(article.title)}
                  title={`${t(article.title)} — CSSBuy Spreadsheet`}
                  className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
                />
              </div>
              <div className="p-5 md:p-6">
                <span className="inline-block px-3 py-1 bg-secondary-100 text-secondary-800 text-xs font-medium rounded-full mb-3">
                  {t(article.category)}
                </span>
                <h3 className="text-lg font-heading font-semibold text-foreground-950 mb-2 group-hover:text-primary-600 transition-colors">
                  {t(article.title)}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                  {t(article.description)}
                </p>
                <div className="flex items-center justify-between">
                  <span className="text-xs text-foreground-400">
                    {t('updated_date')}: {article.updated}
                  </span>
                  <span className="text-sm font-medium text-primary-500 flex items-center gap-1 group-hover:gap-2 transition-all">
                    {t('article_read_more')}
                    <i className="ri-arrow-right-line" />
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}